import { MatterIncidentDetails } from "@/components/features/matter/incident/MatterIncidentDetails";
import { MatterIncidentReports } from "@/components/features/matter/incident/MatterIncidentReports";
import { Card, CardContent } from "@/components/ui";
import type { Matter } from "@/lib/types";

export const MatterIncidentPage = ({ matter }: { matter: Matter }) => {
  return (
    <div className="bg-background flex min-h-full w-full flex-col gap-4 px-6 py-5">
      {(!matter.incidentType || matter.incidentType.incidentModuleAccess) && (
        <Card className="border-border h-min rounded-[24px] border shadow-none">
          <CardContent className="bg-card p-4 sm:p-5">
            <MatterIncidentDetails matter={matter} noBorder />
          </CardContent>
        </Card>
      )}

      {(!matter.incidentType ||
        matter.incidentType.incidentReportModuleAccess) && (
        <Card className="border-border h-min rounded-[24px] border shadow-none">
          <CardContent className="p-0">
            <MatterIncidentReports matter={matter} />
          </CardContent>
        </Card>
      )}
    </div>
  );
};
